import { useState } from 'react'
import { useForm, SubmitHandler, Controller } from 'react-hook-form'
import { Box } from '@mui/material'
import MailOutline from '@mui/icons-material/MailOutline'
import Wrapper from '../../Wrapper/Wrapper'
import ModalWindow from 'components/Modal/Modal'
import Input from 'components/common/BaseInput/BaseInput'
import TextField from 'components/common/BaseTextField/BaseTextField'
import Text from 'components/common/BaseText/BaseText'
import Button from 'components/common/BaseButton/BaseButton'
import Spinner from 'components/Spinner/Spinner'
import { emailRegex, messageRegex } from '../../../constants/index'
import { ContactInputsInterface } from './Contact.types'
import './Contact.scss'

const Contact: React.FC = () => {
	const [emailError, setEmailError] = useState('')
	const [messageError, setMessageError] = useState('')

	const [modalIsOpen, setModalIsOpen] = useState(false)

	const [isLoading, setIsLoading] = useState(false)

	const { handleSubmit, control, reset } = useForm<ContactInputsInterface>()

	// TODO: Move this logic to utils
	const encode = (data: any) => {
		return Object.keys(data)
			.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
			.join('&')
	}

	const onSubmit: SubmitHandler<ContactInputsInterface> = ({ email, message }) => {
		setEmailError('')
		setMessageError('')

		if (!emailRegex.test(email)) {
			setEmailError('Incorrect e-mail')

			return
		}

		if (!messageRegex.test(message)) {
			setMessageError('Incorrect message')

			return
		}

		setIsLoading(true)

		fetch('/', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: encode({ 'form-name': 'contact', email: email, message: message }),
		}).then(res => {
			setIsLoading(false)

			if (res.ok) {
				reset()
				setModalIsOpen(true)
			} else {
				console.log(`${res.status}: ${res.statusText}`)
			}
		})
	}

	if (isLoading) {
		return <Spinner />
	}

	return (
		<Wrapper className='contact' id='contact'>
			<div className='contact__container-title'>
				<h3 className='contact__title'>Contact</h3>
			</div>

			<div className='contact__form-container'>
				<div className='form-container__direct-message'>
					<span className='direct-message__title'>Start by </span>
					<span className='direct-message__title direct-message__title--highlighted'>saying hi</span>
					<span className='direct-message__title'>! Tell me about your project.</span>

					<p className='direct-message__subtitle'>Let's make something amazing!</p>
					<div className='direct-message__e-mail-container'>
						<div className='e-mail-container__icon'>
							<MailOutline />
						</div>
						<div className='e-mail-container__text'>
							<p>Mail me at</p>
							<p className='text--bold'>mpocwiardowski@o2.pl</p>
						</div>
					</div>
				</div>

				<Box className='form-container__form' component='form' sx={{ margin: 0, width: '100%' }} data-netlify='true'>
					<Controller
						name='email'
						control={control}
						defaultValue=''
						render={({ field: { onChange, value } }) => (
							<Input
								sx={{
									width: '100%',
									borderRadius: '3rem',
								}}
								required
								id='email'
								label='Your E-mail'
								type='email'
								onChange={onChange}
								value={value}
							/>
						)}
					/>
					{!!emailError && <Text sx={{ color: 'red' }}>{emailError}</Text>}

					<Controller
						name='message'
						control={control}
						defaultValue=''
						render={({ field: { onChange, value } }) => (
							<TextField
								sx={{
									width: '100%',
									borderRadius: '3rem',
								}}
								required
								id='message'
								label='Message'
								type='text'
								minRows={10}
								onChange={onChange}
								value={value}
							/>
						)}
					/>
					{!!messageError && <Text sx={{ color: 'red' }}>{messageError}</Text>}

					<Button sx={{ marginTop: '.5rem ' }} type='contained' onClick={handleSubmit(onSubmit)}>
						Send
					</Button>
				</Box>
			</div>

			<ModalWindow
				modalIsOpen={modalIsOpen}
				closeModalHandler={() => {
					setModalIsOpen(false)
				}}
				title='Thank you!'
				subtitle='Your message was sent successfully.'
			/>
		</Wrapper>
	)
}

export default Contact
